/**
 * Generates a URL-friendly slug from a neighbourhood name, e.g. "King & Spadina" -> "king-and-spadina".
 * The API only returns neighbourhood name + count, never a slug, so this is derived client-side
 * wherever a neighbourhood needs to link to its own page.
 */
export function generateNeighbourhoodSlug(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9-]+/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}
